import { axios } from './axios';
import {
  CountryCode,
  PostCheckoutSurveyOption,
  PostCheckoutSurveyOptionStatus,
} from '../pages/types';

export const getPostCheckoutSurveyOptions = async (
  country?: CountryCode
): Promise<PostCheckoutSurveyOption[]> => {
  const query = country ? `?country=${country}` : '';
  const response = await axios.get<PostCheckoutSurveyOption[]>(
    `/post_checkout_survey_options/${query}`
  );
  return response.data;
};

type CreatePostCheckoutSurveyOptionData = {
  label: string;
  value: string;
  status: PostCheckoutSurveyOptionStatus;
  country: CountryCode;
  marketing_source: string;
  marketing_bucket: string;
};

export const createPostCheckoutSurveyOption = async (data: CreatePostCheckoutSurveyOptionData) => {
  const response = await axios.post('/post_checkout_survey_options/', data);
  return response.data;
};

type UpdatePostCheckoutSurveyOptionData = {
  label?: string;
  marketing_source?: string;
  marketing_bucket?: string;
  status?: PostCheckoutSurveyOptionStatus;
};

export const updatePostCheckoutSurveyOption = async (
  id: string,
  data: UpdatePostCheckoutSurveyOptionData
) => {
  const response = await axios.patch(`/post_checkout_survey_options/${id}/`, data);
  return response.data;
};
